import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ButtonGroupOptions, ButtonType, ButtonGroupComponent } from '@shared/ui/buttons';
import { IconType } from '@shared/utils/icons';
import { NavbarHeaderMenuItem } from '@shared/utils/menu-items';
import { AppConfig } from '@shared/utils/app-config';
import { Router } from '@angular/router';
import { AppRoutes } from '@shared/utils/navigation';

@Component({
    selector: 'shared-ui-navbars-navbar-header',
    templateUrl: './navbar-header.component.html',
    styleUrls: ['./navbar-header.component.css'],
    standalone: false
})
export class NavbarHeaderComponent implements OnInit {
  @Input() heading?: string;
  @Input() imageUrl?: string;
  @Input() subheading?: string;
  @Input() subheadingDropdown?: NavbarHeaderMenuItem[] | null;
  @Input() dropdownPlacement?: string;
  @Input() userDetailsInDropdown = true;
  @Input() userUid?: string;
  @Input() canOpenUserProfile = false;
  @ViewChild(ButtonGroupComponent) buttonGroupComponent?: ButtonGroupComponent;

  buttonOptions?: ButtonGroupOptions[];
  ButtonType = ButtonType;

  constructor(public appConfig: AppConfig, private router: Router) {}

  ngOnInit(): void {
    if (this.subheadingDropdown) {
      this.buttonOptions = this.subheadingDropdown.map((x) => {
        if (x.callback) {
          return new ButtonGroupOptions(x.text, x.callback, IconType.None, x.link);
        }

        return new ButtonGroupOptions(x.text, () => {}, IconType.None, x.link);
      });
    }
  }

  openUserDashboard(): void {
    if (this.userUid && this.canOpenUserProfile) {
      this.router.navigate([`/${AppRoutes.Users}/${this.userUid}`]);
    }
  }
}
